import { render, staticRenderFns } from "./About.vue?vue&type=template&id=f0b1f3d0&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports